// extracted by mini-css-extract-plugin
export var bgIcon = "index-module--bgIcon--7dca9";
export var item = "index-module--item--1a43a";
export var link = "index-module--link--c0e5d";